import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import {
    fillSearchMagnifier,
    suggestionText,
    suggestionWrapper
} from '../../../theme/default-theme';
import { ContentSpacing } from 'elc-base-theme';
import { SearchIcon } from 'elc-icons';
import { translate, ITranslationsCollection } from 'elc-service';
import { IItemTypeahead } from '../../../internal/interfaces/ISearchInterfaces';
import { formatDataAttribute } from '../../utils/FormatDataAttritube';
import {
    SEARCH_TYPE_PARAM,
    PREDICTIVE_SEARCH_PARAM,
    FILTERS_SEARCH_PARAM
} from '../../constants/Search';

const SuggestionDimensionWrapper = styled.li`
    padding: ${ContentSpacing.space10} 0;
    ${suggestionWrapper};
    text-align: left;
`;

const SuggestionLink = styled.a`
    margin: 0;
    display: inline-block;
    vertical-align: middle;
    max-width: 400px;
    overflow: hidden;
    ${suggestionText};
`;

const SearchIconSuggestion = styled.span`
    display: inline-block;
    vertical-align: middle;
    padding: 0 ${ContentSpacing.space16} 0 ${ContentSpacing.space10};

    .elc-icon-search-suggestion {
        .elc-icon-search-magnifier {
            ${fillSearchMagnifier};
        }
    }
`;

const SearchTermSuggestion = styled.span``;

const SearchInSuggestion = styled.span``;

const SearchTypeaheadValue = styled.span``;

const SearchTypeaheadCount = styled.span``;

export interface ISearchSuggestionListProps {
    inputValue: string;
    translations?: ITranslationsCollection;
    searchUrl?: string;
    limiteTypeaheadResults: IItemTypeahead[];
    typeaheadResults: IItemTypeahead[];
    filterParam: string;
    searchParam: string;
    searchTermSelected(searchTerm: string): () => void;
}

@translate(['inCategoryLabel'])
@observer
export class SearchSuggestionList extends React.Component<ISearchSuggestionListProps> {
    public render() {
        const searchSuggestionsValue = classnames(
            'elc-search-suggestion-value',
            'js-search-suggestion-value'
        );

        const searchIconSuggestionClassnames = classnames(
            'elc-search-suggestion-icon-wrapper',
            'js-search-suggestion-icon-wrapper'
        );
        const searchIconclassnames = classnames(
            'elc-search-suggestion-icon',
            'js-search-suggestion-icon'
        );

        const circleIconSearchClassnames = classnames(
            'elc-icon-search-circle',
            'js-icon-search-circle'
        );
        const magnifierIconSearchClassnames = classnames(
            'elc-icon-search-magnifier',
            'js-icon-search-magnifier'
        );

        const searchSuggestionLinkClassnames = classnames(
            'elc-search-suggestion-link',
            'js-search-suggestion-link'
        );

        const searchSearchTermSuggestion = classnames(
            'elc-search-term-suggestion',
            'js-search-term-suggestion'
        );

        const searchSearchInSuggestion = classnames(
            'elc-search-in-suggestion',
            'js-search-in-suggestion'
        );

        const searchTypeaheadValue = classnames(
            'elc-search-typeahead-value',
            'js-search-typeahead-value'
        );

        const searchTypeaheadCount = classnames(
            'elc-search-typeahead-count',
            'js-search-typeahead-count'
        );

        const {
            inputValue,
            limiteTypeaheadResults,
            filterParam,
            searchParam,
            searchUrl,
            typeaheadResults,
            searchTermSelected
        } = this.props;
        const { inCategoryLabel } = this.props.translations as ITranslationsCollection;

        return (
            typeaheadResults.length > 0 &&
            limiteTypeaheadResults.map((typeaheadValue: IItemTypeahead) => (
                <SuggestionDimensionWrapper
                    data-test-id="SEA-Suggestion"
                    key={typeaheadValue.link}
                    className={searchSuggestionsValue}
                >
                    <SearchIconSuggestion className={searchIconSuggestionClassnames}>
                        <SearchIcon
                            className={searchIconclassnames}
                            pathMagnifierClassName={magnifierIconSearchClassnames}
                            pathCircleClassName={circleIconSearchClassnames}
                        />
                    </SearchIconSuggestion>
                    <SearchTermSuggestion className={searchSearchTermSuggestion}>
                        {inputValue}
                    </SearchTermSuggestion>
                    <SearchInSuggestion className={searchSearchInSuggestion}>
                        {inCategoryLabel}
                    </SearchInSuggestion>
                    <SuggestionLink
                        className={searchSuggestionLinkClassnames}
                        href={`${searchUrl}${searchParam}${encodeURIComponent(
                            typeaheadValue.label
                        )}${filterParam}${
                            typeaheadValue.link
                        }${SEARCH_TYPE_PARAM}${PREDICTIVE_SEARCH_PARAM}${FILTERS_SEARCH_PARAM}`}
                        role="button"
                        aria-label={typeaheadValue.label}
                        onClick={searchTermSelected(typeaheadValue.label)}
                        title={typeaheadValue.label}
                    >
                        <SearchTypeaheadValue
                            className={searchTypeaheadValue}
                            data-test-id={`SEA-Predective-Result-${formatDataAttribute(
                                typeaheadValue.label
                            )}`}
                        >
                            {typeaheadValue.label}
                        </SearchTypeaheadValue>
                    </SuggestionLink>
                    {typeaheadValue.count ? (
                        <SearchTypeaheadCount className={searchTypeaheadCount}>
                            ({typeaheadValue.count})
                        </SearchTypeaheadCount>
                    ) : null}
                </SuggestionDimensionWrapper>
            ))
        );
    }
}
